module.exports = __webpack_public_path__ + "img/drone_06_H.96e28765.webp";